import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../lib/CartContext";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [data, setData] = useState(null);
  const { refresh } = useCart();
  const polledRef = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let active = true;
    const poll = async () => {
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        if (!active) return;
        if (r.data.payment_status === "paid") {
          setStatus("paid"); setData(r.data); refresh();
          return;
        }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        polledRef.current += 1;
        if (polledRef.current >= 5) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
    return () => { active = false; };
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <main className="pt-40 pb-32 min-h-screen" data-testid="checkout-success">
      <div className="max-w-2xl mx-auto px-6 text-center">
        {status === "checking" && (
          <>
            <p className="font-serif text-3xl text-[#A39E8A] mb-4">Verificăm plata...</p>
            <div className="h-1 w-40 mx-auto shimmer-gold" />
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={56} strokeWidth={1} className="text-[#D4AF37] mx-auto mb-6" />
            <p className="label-luxe text-[#D4AF37] mb-4">Plată Confirmată</p>
            <h1 className="h-display text-5xl sm:text-6xl text-[#F8F4E6] mb-6">Mulțumim</h1>
            <p className="text-[#A39E8A] mb-10">
              Comanda ta de {data?.amount_total ? (data.amount_total / 100).toFixed(2) : ""} {data?.currency?.toUpperCase()} a fost confirmată. Vei primi un email cu detaliile.
            </p>
            <div className="flex gap-4 justify-center flex-wrap">
              <Link to="/account" className="btn-gold" data-testid="view-orders">Vezi Comenzile</Link>
              <Link to="/shop" className="btn-ghost">Continuă Cumpărăturile</Link>
            </div>
          </>
        )}
        {(status === "expired" || status === "timeout" || status === "error") && (
          <>
            <p className="font-serif text-3xl text-[#F8F4E6] mb-4">Plata nu a putut fi finalizată</p>
            <p className="text-[#A39E8A] mb-8">Te rugăm să reîncerci sau să ne contactezi.</p>
            <Link to="/cart" className="btn-gold">Înapoi la Coș</Link>
          </>
        )}
      </div>
    </main>
  );
}
